<template>
  <Teleport :to="teleportTarget">
    <transition name="dialog-t">
      <div
        v-if="active"
        v-bind="$attrs"
        ref="container"
        class="vs-component con-vs-dialog"
        :class="`vs-dialog-${color}`"
      >
        <div class="vs-dialog-dark" @click="handleBackdrop" />
        <div ref="dialog" class="vs-dialog">
          <header class="vs-dialog-header" :style="headerStyle">
            <div class="con-title-after">
              <span class="after" :style="accentStyle" />
              <h3 class="dialog-title">{{ title }}</h3>
            </div>
          </header>
          <div class="vs-dialog-text">
            <slot />
            {{ text }}
          </div>
          <footer v-if="!buttonsHidden">
            <vs-button
              class="vs-dialog-accept-button"
              :disabled="isValid === 'none' ? false : !isValid"
              :color="color"
              :type="buttonAccept"
              @click="acceptDialog"
            >
              {{ acceptText }}
            </vs-button>
            <vs-button
              class="vs-dialog-cancel-button"
              text-color="rgba(0,0,0,.5)"
              :type="buttonCancel"
              @click="cancelDialog"
            >
              {{ cancelText }}
            </vs-button>
          </footer>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<script>
const THEME_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
];

export default {
  name: "VsPrompt",
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: "primary",
    },
    active: {
      type: Boolean,
      default: false,
    },
    buttonAccept: {
      type: String,
      default: "filled",
    },
    buttonCancel: {
      type: String,
      default: "flat",
    },
    isValid: {
      type: [Boolean, String],
      default: "none",
    },
    buttonsHidden: {
      type: Boolean,
      default: false,
    },
    acceptText: {
      type: String,
      default: "Accept",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    closeIcon: {
      type: String,
      default: "close",
    },
    text: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: "Dialog",
    },
    type: {
      type: String,
      default: "alert",
    },
    parent: {
      default: null,
    },
  },
  emits: ["update:active", "accept", "cancel", "close"],
  computed: {
    teleportTarget() {
      return this.parent || "body";
    },
    customColor() {
      return THEME_COLORS.includes(this.color) ? null : this.color;
    },
    headerStyle() {
      return {
        color: this.customColor,
      };
    },
    accentStyle() {
      return {
        background: this.customColor,
      };
    },
  },
  methods: {
    close() {
      this.$emit("update:active", false);
    },
    acceptDialog() {
      if (!this.isValid && this.isValid !== "none") return;
      this.close();
      this.$emit("accept");
    },
    cancelDialog() {
      this.close();
      this.$emit("cancel");
    },
    handleBackdrop(event) {
      if (!event.target.classList.contains("vs-dialog-dark")) return;
      if (this.type === "alert") this.close();
      else this.rebound();
      this.$emit("close");
    },
    rebound() {
      if (!this.$refs.dialog) return;
      this.$refs.dialog.classList.add("locked");
      setTimeout(() => {
        if (this.$refs.dialog) this.$refs.dialog.classList.remove("locked");
      }, 200);
    },
  },
};
</script>
